<section class="hero-section">
  <section>
    <h1 class="glitch" [attr.data-text]="mainTitle">{{mainTitle}}</h1>
    <p>{{subtitle}}</p>
  </section>
</section>